import { render } from "./ReviewMediaModal.vue?vue&type=template&id=0c4171a2&scoped=true"
import script from "./ReviewMediaModal.vue?vue&type=script&lang=js"
export * from "./ReviewMediaModal.vue?vue&type=script&lang=js"

import "./ReviewMediaModal.vue?vue&type=style&index=0&id=0c4171a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4171a2"]])

export default __exports__